
import React from "react"

const YoutubeEmbed = (props) => (
  <div className="Youtube">
    <div className="Emulator__bar">
      <button onClick={() => props.hideVideo(props.id)}></button>
    </div>
    <iframe width="560" height="315" src={`https://www.youtube.com/embed/${props.video}?autoplay=1&modestbranding=1&iv_load_policy=3&rel=0`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
  </div>
)

export default YoutubeEmbed